import { useState, useRef, useEffect } from 'react';
import { IonModal, IonButton, IonIcon, IonBadge, IonGrid, IonRow, IonCol, IonLabel, IonTextarea, useIonToast } from '@ionic/react';
import { close, informationCircleOutline, attachOutline, cloudUploadOutline } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { Storage } from '@capacitor/storage';
import { ToBase64 } from '../../../defines/Functions';
import axios from 'axios';
import moment from 'jalali-moment';
import './ProfileTicketDetails.css';
import Loading from '../../Loading';

interface Props {
    ticketId: number
}
const ProfileTicketDetails = (props: Props) => {
    const profileTicketDetail = Constants.api.profileTicketDetail;
    const profileTicketReply = Constants.api.profileTicketReply;
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        });
    };
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showProfileTicketDetailsModal: false,
        token: '',
        data: [] as any
    });
    const [formData, setFormData] = useState({
        text: '',
        attachements: [] as any
    });
    const [required, setRequired] = useState({
        text: { value: false, message: '' }

    });
    const userDataRef = useRef(false);
    const getUserData = async () => {
        if (!userDataRef.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setState({ ...state, token: objectValue.token });
            } else {
                return false;
            }
        }
        userDataRef.current = true;
    }
    getUserData();
    const getTicketDetails = async () => {
        setLoading(true);
        try {
            const detailsResults = await axios.get(profileTicketDetail + props.ticketId, {
                headers: {
                    Authorization: 'Bearer ' + state.token
                }
            });
            if (detailsResults.status === 200) {
                setState(prevState => ({ ...prevState, data: detailsResults.data.items }));
                setLoading(false);
            }
        } catch (error: any) {
            console.log(error);
            setLoading(false);
        }
    }
    useEffect(() => {
        if (state.showProfileTicketDetailsModal) {
            getTicketDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileTicketDetail, props.ticketId, state.showProfileTicketDetailsModal, state.token]);
    const getFile = async () => {
        const file = document.querySelector('#myfile') as any;
        if (file) {
            const fileContent = await ToBase64(file.files[0]);
            const fileName = file.files[0].name;
            setFormData(prevFromData => ({
                ...prevFromData,
                attachements: [...prevFromData.attachements, { file_name: fileName, file_content: fileContent }]
            }))
        }
    }
    const removeFile = (index: number) => {
        const formAttachments = formData.attachements;
        formAttachments.splice(index, 1);
        setFormData(prevFormData => ({ ...prevFormData, attachements: formAttachments }));
    }
    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.detail.value;
        setFormData(values => ({ ...values, [name]: value }));
    }
    const handleBlur = () => {
        if (formData.text.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: false, message: '' } } });
        }
    }
    const handleSubmit = (event: any) => {
        let isRequired = false;
        event.preventDefault();
        if (formData.text.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: false, message: '' } } });
            isRequired = false;
        }
        if (!isRequired) {
            submitForm();
        }
    }
    const submitForm = async () => {
        setLoading(true);
        const submitData = {
            support_tickets_replies: [{
                text: formData.text,
                attachements: formData.attachements
            }]
        }
        try {
            const formResults = await axios.post(profileTicketReply + props.ticketId, JSON.stringify(submitData), {
                headers: {
                    Authorization: 'Bearer ' + state.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (formResults.data.result === 'error') {
                setFormData({
                    ...formData,
                    text: '',
                    attachements: []
                });
                showToast({ message: formResults.data.message, color: 'danger' });
                setLoading(false);
            } else {
                setFormData({
                    ...formData,
                    text: '',
                    attachements: []
                });
                showToast({ message: formResults.data.message, color: 'success' });
                getTicketDetails();
                setLoading(false);
            }
        } catch (error: any) {
            console.log(error);
            showToast({ message: error.response.data.message, color: 'danger' });
            setLoading(false);
        }
    }
    return (
        <>
            <IonModal isOpen={state.showProfileTicketDetailsModal} onDidDismiss={() => setState({ ...state, showProfileTicketDetailsModal: false })} mode="ios" cssClass="profile-ticket-details-modal">
                {!loading ?
                    state.data.length !== 0 &&
                    <div className="profile-ticket-details-modal-content">
                        <h3 className="profile-ticket-details-modal-title">
                            جزئیات تیکت
                            <IonIcon icon={close} onClick={() => setState({ ...state, showProfileTicketDetailsModal: false })} />
                        </h3>
                        <ul className="ticket-info">
                            <li>
                                <b>شماره تیکت :</b>
                                <span>#{state.data[0].ticket.id}</span>
                            </li>
                            <li>
                                <b>دسته بندی :</b>
                                <span>
                                    {state.data[0].ticket.category_id.title} / {state.data[0].ticket.sub_category_id.title}
                                </span>
                            </li>
                            <li>
                                <b>عنوان :</b>
                                <span>{state.data[0].ticket.title}</span>
                            </li>
                            <li>
                                <b>شماره قرارداد :</b>
                                <span>{state.data[0].ticket.contract_id}</span>
                            </li>
                            <li>
                                <b>وضعیت :</b>
                                <span>
                                    {state.data[0].ticket.status === 'N' ?
                                        <IonBadge color="danger">منتظر پاسخ پشتیبان</IonBadge>
                                        :
                                        <IonBadge color="success">تایید پاسخ پشتیبان</IonBadge>
                                    }
                                </span>
                            </li>
                        </ul>
                        {state.data[0].replies.map((item: any, index: number) =>
                            item.type === 'C' ?
                                <div className="ticket-text" key={"index" + index}>
                                    <div className="title">
                                        <span>ارسال شده توسط شما</span>
                                        <span>{moment(item.datetime).locale('fa').format('YYYY/MM/DD ساعت H:M')}</span>
                                    </div>
                                    <div className="text">
                                        <pre>
                                            {item.text}
                                        </pre>
                                        <span className="attachment">
                                            <a href={Constants.uploads + 'support_tickets/' + item.attachements} target="_blank" rel="noreferrer">
                                                <IonIcon icon={attachOutline} />
                                                2021_03_15_2549498.png
                                            </a>
                                        </span>
                                    </div>
                                </div>
                                :
                                <div className="ticket-reply">
                                    <div className="title">
                                        <span>ارسال شده توسط پشتیبان طاهاگشت</span>
                                        <span>1400/10/19 ساعت 12:35</span>
                                    </div>
                                    <div className="text">
                                        <pre>
                                            پاسخ پشتیبان به پیام شما
                                        </pre>
                                        <span className="attachment">
                                            <IonIcon icon={attachOutline} />
                                            2021_03_15_2549498.png
                                        </span>
                                    </div>
                                </div>
                        )}
                        <div className="ticket-note">
                            <p>به درخواست های شما طی نهایتا ۲۴ ساعت کاری پاسخ داده خواهد شد. توضیح کامل و جامع‌تر شما باعث سریعتر پاسخ داده شدن درخواست می‌شود.</p>
                        </div>
                        <div className="profile-ticket-details-modal-input-container">
                            {!loading ?
                                <form onSubmit={handleSubmit}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size="12">
                                                <IonLabel>
                                                    متن درخواست
                                                    {required.text.value ? <span className="required">{required.text.message}</span> : null}
                                                </IonLabel>
                                                <IonTextarea rows={7} name="text" value={formData.text || ""} onIonChange={e => handleChange(e)} onIonBlur={handleBlur}></IonTextarea>
                                            </IonCol>
                                            <IonCol size="12">
                                                <label className="file-uploader">
                                                    <IonIcon icon={cloudUploadOutline} />
                                                    <span>فایل خود را آپلود کنید</span>
                                                    <input type="file" hidden id="myfile" onChange={getFile} accept="image/*,.pdf,.zip" />
                                                </label>
                                                {formData.attachements.length !== 0 &&
                                                    <div className="file-preview">
                                                        <IonGrid>
                                                            <IonRow>
                                                                {formData.attachements.map((item: any, index: number) =>
                                                                    <IonCol size="4" key={"index" + index}>
                                                                        <div className="file-preview-item">
                                                                            <IonIcon icon={close} onClick={() => removeFile(index)} />
                                                                            <span>{item.file_name}</span>
                                                                        </div>
                                                                    </IonCol>
                                                                )}
                                                            </IonRow>
                                                        </IonGrid>
                                                    </div>
                                                }
                                            </IonCol>
                                            <IonCol size="12">
                                                <IonButton type="submit" color="warning" expand="block">
                                                    ارسال پاسخ
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                </form>
                                :
                                <Loading />
                            }
                        </div>
                    </div>
                    :
                    <Loading />
                }
            </IonModal>
            <IonButton color="warning" onClick={() => setState({ ...state, showProfileTicketDetailsModal: true })}>
                <IonIcon icon={informationCircleOutline} />
            </IonButton>
        </>
    );
};
export default ProfileTicketDetails;